import { render } from "./AppHero.vue?vue&type=template&id=022eaa13&ts=true"
import script from "./AppHero.vue?vue&type=script&lang=ts"
export * from "./AppHero.vue?vue&type=script&lang=ts"

import "./AppHero.vue?vue&type=style&index=0&id=022eaa13&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__